import { render, staticRenderFns } from "./NonVegBlogPostsCard.vue?vue&type=template&id=64d2e5d4&scoped=true&"
import script from "./NonVegBlogPostsCard.vue?vue&type=script&lang=js&"
export * from "./NonVegBlogPostsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2e5d4",
  null
  
)

export default component.exports